<template>
  <div id="app" class="container">
    <div class="row">
      <div class="col-md-12">
        <web-header></web-header>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
          <login-form v-if="!checkLoginState"></login-form>
          <login-info v-else></login-info>
          <menu-d-m-s-c v-show="checkLoginState"></menu-d-m-s-c>
      </div>
      <div class="col-md-9">
        <router-view>

        </router-view>
      </div>
    </div>
    <div class="row ">
      <div class="col-md-12">
        กรมวิทยาศาสตร์การแพทย์  swindowone@gmail.com
      </div>
      <br /><br />
    </div>
  </div>
</template>

<script>
import store from './vuex/store'
import Vuex from 'vuex'
global.vuex = Vuex
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import WebHeader from './components/WebHeader.vue'
import LoginForm from './components/LoginForm.vue'
import LoginInfo from './components/LoginInfo.vue'
import MenuDMSC from './components/MenuDMSC.vue'

export default {
  store,
  name: 'app',
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    WebHeader,
    LoginForm,
    LoginInfo,
    MenuDMSC
  },
  computed: {
    todos () {
      return store.state.todos
    },
    checkLoginState () {
      return store.state.is_login
    }
  }
}
</script>

<style>
@import './assets/mushroom.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// App.vue?487e5420